import { SimpleTruncate } from "@/helpers/Text";
import ActivityMenu from "../../menus/ActivityMenu";
import { IUserCommentProps } from "@/interfaces/activityFeed";
import "../../../../../css/activityFeed/elements/user-comment.scss"


const UserComment = ({zIndexNum, commentText, truncateNumber, isOriginalComment, className, onLikeClick, isLiked, isReply, onReplyClick, getWebLink, onDeleteClick, hideMenu}: IUserCommentProps) => {

    return (
        <div className={`user-commment-wrapper ${className ?? ""} ${isOriginalComment ? "original-comment" : ""}`} style={zIndexNum !== undefined ? { zIndex: zIndexNum } : undefined}>
            <span className="user-comment">
                <span className={`comment-text`}>
                    “
                    <span className="truncated-text">{commentText && SimpleTruncate(commentText, truncateNumber)}</span>”
                
                </span>
            </span>

            {!isOriginalComment && !hideMenu && <ActivityMenu  onLikeClick={onLikeClick} isLiked={isLiked}  onReplyClick={onReplyClick ?? undefined} getWebLink={getWebLink}  onDeleteClick={onDeleteClick} isReply={isReply}/>}
        </div>
    );
};

export default UserComment